import './step.scss';
import '../../../styles/form/_form.scss';
import '../../../styles/_block-waiting-holders.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';
import cryptoJS from 'crypto-js';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import optionsActions from 'actions/optionsActions';
import focusActions from 'actions/focusActions';
import preLoaderActions from 'actions/preLoaderActions';
import jointHoldersStatusActions from 'actions/jointHoldersStatusActions';
import createActions from 'actions/createActions';
import accountTypeActions from 'actions/accountTypeActions';
import standByActions from 'actions/standByActions';
import { stopPolling } from 'actions/polling';
import { AccountType } from 'components/accountType/';
import { RadioButton } from 'components/RadioButton/RadioButton';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import Disclaimer from 'components/containers/disclaimer';
import Headline from 'components/headline';
import { StandByHC } from 'components/newAccountSteps/profileSteps/standByHC';
import { formatText } from 'core/i18n';
import scroll from 'utilities/scroll';
import {
    EMPLOYED_ID,
    PENSIONER_ID,
    RENTIER_ID,
    SELF_EMPLOYED_ID,
    WITHOUT_ACTIVITY_ID,
} from 'utilities/professionHelper';
import {
    recordEvent,
    recordCreateNewClient,
    recordEventStepSuccess,
    recordError,
    PAGE_PRODUCT,
    errorTag,
} from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import { PATH_PROFESSION } from 'constants/uTagConstants/paths';
import { ERROR_CASO_EMPLEADO } from 'constants/analyticsErrors';
import { CREDIT_CARD } from 'constants/userProfile';
import consentsActions from 'actions/consentsActions';
import { createClientWithConsent } from 'components/newAccountSteps/profileSteps/services/createClientWithConsent';
import { goToErrorsView, recordAndSavePage } from 'actions/errorViewNavigation';

const validationsList = {
    selfEmployed: {
        primaries: ['selfEmployed_company', 'profession_id', 'profession_cnae_answer'],
    },
    employed: {
        primaries: ['profession_option', 'employed_company'],
    },
    rentier: {
        primaries: [],
    },
    pensioner: {
        primaries: [],
    },
    withoutActivity: {
        primaries: ['withoutActivity_activity'],
    },
};

class ProfileStep2Reduced extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoadingTypeOfAccounts: true,
            showModalNonExclusiveKO: false,
            blowupClass: 'blowup-modal blowup-in',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.formValidations = validationsList;
        this.getCountries = this.getCountries.bind(this);
        this.getWorkFor = this.getWorkFor.bind(this);
        this.onHandleValidateFields = this.onHandleValidateFields.bind(this);
        this.handleResetFields = this.handleResetFields.bind(this);
        this.buildModalNonExclusiveKO = this.buildModalNonExclusiveKO.bind(this);
        this.handleShowNonExclusiveModal = this.handleShowNonExclusiveModal.bind(this);
        this.handleHideNonExclusiveModal = this.handleHideNonExclusiveModal.bind(this);
        this.typeOfAccounts = [];
        this.saveFiocData = this.saveFiocData.bind(this);
        this.saveSelfEmployed = this.saveSelfEmployed.bind(this);
        this.saveEmployed = this.saveEmployed.bind(this);
        this.saveWithoutActivity = this.saveWithoutActivity.bind(this);
        this.handleBlowupClass = this.handleBlowupClass.bind(this);
        this.handleDisableButton = this.handleDisableButton.bind(this);
        this.getRequiredFields = this.getRequiredFields.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { options, optionsActions } = this.props;

        if (options.get('countries').size == 0) {
            optionsActions.getCountries();
        }
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { jointHoldersStatusActions, userProfile, products, immStepsState, recordAndSavePage } = this.props;
        const accessToken = userProfile.accessToken;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        if (userProfile.status !== 'waiting') {
            const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
            !immStepsState.get('welcomeCard') &&
                recordAndSavePage(
                    PATH_PROFESSION,
                    userProfile.recordId,
                    userProfile.userId,
                    userProfile.product,
                    products.get('productsDescription'),
                    userProfile.promoCode ? userProfile.promoCode : '',
                    JointHolderInfo,
                    '',
                    '',
                    userProfile.investmentType,

                    { identificadorOnboarding: docNumberEncrypted }
                );
        }

        if (userProfile.status === 'waiting') {
            jointHoldersStatusActions.statusHolders(accessToken);
        }
    }

    componentDidUpdate() {
        const { userProfileForm } = this.props;

        if (!userProfileForm.$form.valid && this.props.focus.get('triggerValidations')) {
            const errosElements = document.getElementsByClassName('valid-error');
            if (errosElements.length > 0) {
                const input =
                    errosElements[0].getElementsByTagName('input')[0] ||
                    errosElements[0].getElementsByClassName('Select-control')[0];
                if (input) {
                    scroll.transition(input);
                } else {
                    this.props.focusActions.setFocusForm(errosElements[0].id);
                }
            }
            this.props.focusActions.triggerValidations(false);
        }
    }

    componentWillUnmount() {
        const { formActions } = this.props;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        let requiredFields;

        if (!disabled) {
            requiredFields = this.getRequiredFields();

            for (let i = 0; i < requiredFields.length; i++) {
                formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: true });
            }
        }
        stopPolling();
    }

    getWorkFor() {
        const workFor = [
            { value: '02', label: formatText('informationText-workFor02') },
            { value: '01', label: formatText('informationText-workFor01') },
            { value: '03', label: formatText('informationText-workFor03') },
            { value: '04', label: formatText('informationText-workFor04') },
            { value: '05', label: formatText('informationText-workFor05') },
        ];

        return workFor;
    }

    /*
     * Function that fill data into input select nationality
     */
    getCountries() {
        const countries = [];
        this.props.options.get('countries').map(function (value) {
            countries.push(value.toObject());
        });

        return countries;
    }

    removeValidations(arrayValidations) {
        const { formActions } = this.props;
        for (let i = 0; i < arrayValidations.length; i++) {
            formActions.setValidity(`userProfile.${arrayValidations[i]}`, { required: true });
        }
    }

    getRequiredFields() {
        const { userProfile, formActions } = this.props;
        const accountId = userProfile.accountType ? userProfile.accountType : 0;
        let requiredFields = {};

        switch (accountId) {
            case '01':
                requiredFields = this.formValidations.selfEmployed.primaries;
                // Dynamic validations
                if (userProfile.profession_cnae_answer === 'No') {
                    requiredFields = requiredFields.concat(['profession_category']);
                } else {
                    this.removeValidations(['profession_category']);
                }

                break;
            case '02':
                requiredFields = this.formValidations.employed.primaries;
                // Dynamic validations
                if (userProfile.profession_option) {
                    if (userProfile.profession_option === '1') {
                        requiredFields = requiredFields.concat(['cno1_profession_id']);
                        if (userProfile.cno1_profession_id === '-1') {
                            formActions.change('userProfile.cno1_profession_id', '');
                        }
                    } else {
                        this.removeValidations(['cno1_profession_id']);
                    }
                    if (userProfile.profession_option === '2') {
                        if (userProfile.cno2_profession_id === '-1') {
                            formActions.change('userProfile.cno2_profession_id', '');
                        }
                        requiredFields = requiredFields.concat(['profession_category']);
                        requiredFields = requiredFields.concat(['cno2_profession_id']);
                    } else {
                        this.removeValidations(['cno2_profession_id', 'profession_category']);
                    }
                }

                break;
            case '03': // Rentier
                requiredFields = this.formValidations.rentier.primaries;
                break;
            case '04':
                requiredFields = this.formValidations.pensioner.primaries;
                break;
            case '05':
                requiredFields = this.formValidations.withoutActivity.primaries;
                break;
            default:
                requiredFields = this.formValidations.employed.primaries;
                break;
        }

        return requiredFields;
    }

    onHandleValidateFields() {
        const { userProfile, formActions } = this.props;
        const { userId, recordId, investmentType, docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        let requiredFlag = true;

        this.props.focusActions.triggerValidations(true);

        let fieldsWithError = '';
        let j = 0;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        if (!disabled) {
            const accountId = userProfile.accountType ? userProfile.accountType : 0;
            if (accountId === 0) {
                formActions.setValidity('userProfile.accountType', { required: false });

                return;
            }
            const requiredFields = this.getRequiredFields();
            // Parse validations
            for (let i = 0; i < requiredFields.length; i++) {
                const field = userProfile[requiredFields[i]];
                const inputContainer = document.querySelector(`[id*='${requiredFields[i]}']`);
                const isVisible = inputContainer?.offsetParent;

                if (field === '' || typeof field === 'undefined' || field === null) {
                    if (j == 0) {
                        fieldsWithError += requiredFields[i];
                    } else {
                        fieldsWithError += `|${requiredFields[i]}`;
                    }
                    j++;
                    isVisible && formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: false });
                    requiredFlag = false;
                }
            }
        }

        if (!requiredFlag) {
            recordError(`[${fieldsWithError}]:Campos requeridos para continuar.`, investmentType ? investmentType : '');
            recordEvent(
                PATH_PROFESSION,
                PAGE_PRODUCT,
                'tu actividad',
                'tu actividad incorrecto',
                recordId,
                userId,
                '',
                investmentType ? investmentType : '',
                docNumberEncrypted
            );
        }

        return requiredFlag;
    }

    checkHiddenFields(type, fields, fieldName, value) {
        const { userProfile } = this.props;

        if (userProfile[fieldName] === value) {
            this.state[type].forEach(field => {
                if (fields.indexOf(field.name) > -1) {
                    field.hidden = false;
                }
            });
        } else {
            this.state[type].forEach(field => {
                if (fields.indexOf(field.name) > -1) {
                    field.hidden = true;
                }
            });
        }
    }

    doubleCheckHiddenFields(type, fields, fieldName1, value1, fieldName2, value2) {
        const { userProfile } = this.props;

        if (userProfile[fieldName1] === value1 && userProfile[fieldName2] === value2) {
            this.state[type].forEach(field => {
                if (fields.indexOf(field.name) > -1) {
                    field.hidden = false;
                }
            });
        } else {
            this.state[type].forEach(field => {
                if (fields.indexOf(field.name) > -1) {
                    field.hidden = true;
                }
            });
        }
    }

    saveSelfEmployed(callback) {
        const { userProfile, goToErrorsView } = this.props;
        const accessToken = userProfile.accessToken;
        const data = {};
        const profession = {
            option: userProfile['profession_cnae_answer'],
            subcategory: userProfile['profession_id'],
            id: userProfile['profession_category'],
        };

        data['profession'] = profession;
        data['companyName'] = userProfile.selfEmployed_company;

        return this.props.accountTypeActions.saveSelfEmployedInformation(data, accessToken, (saved, errors) => {
            if (saved) {
                callback();
            } else if (errors['6100']) {
                goToErrorsView({ errorCode: 6100 });
            }
        });
    }

    saveEmployed(callback) {
        const { userProfile, goToErrorsView } = this.props;
        const accessToken = userProfile.accessToken;
        const data = {};
        let idProfession;

        if (userProfile['cno1_profession_id'] && userProfile['cno1_profession_id'] !== '-1') {
            idProfession = userProfile['cno1_profession_id'];
        }
        if (userProfile['cno2_profession_id'] && userProfile['cno2_profession_id'] !== '-1') {
            idProfession = userProfile['cno2_profession_id'];
        }

        const profession = {
            option: userProfile['profession_option'],
            subcategory: userProfile['profession_category'],
            id: idProfession,
        };

        data['profession'] = profession;
        data['companyName'] = userProfile.employed_company;

        return this.props.accountTypeActions.saveEmployedInformation(data, accessToken, (saved, error) => {
            if (saved) {
                callback();
            } else {
                errorTag(error.body, PATH_PROFESSION, ERROR_CASO_EMPLEADO, error.statusCode);
                goToErrorsView({ errorCode: error.statusCode, errorMessage: ERROR_CASO_EMPLEADO });
            }
        });
    }

    saveWithoutActivity(callback) {
        const { userProfile, goToErrorsView } = this.props;
        const accessToken = userProfile.accessToken;
        const data = {};

        data['profession'] = userProfile.withoutActivity_activity;

        return this.props.accountTypeActions.saveUnemployedInformation(data, accessToken, (saved, errors) => {
            if (saved) {
                callback();
            } else if (errors['6100']) {
                goToErrorsView({ errorCode: 6100 });
            }
        });
    }

    saveFiocData(callback) {
        const { userProfile } = this.props;
        const accountId = userProfile.accountType;
        let saved;

        switch (accountId) {
            case '01':
                saved = this.saveSelfEmployed;
                break;
            case '02':
                saved = this.saveEmployed;
                break;
            case '05':
                saved = this.saveWithoutActivity;
                break;
            default:
                saved = null;
                break;
        }

        if (saved) {
            return saved(callback);
        }

        return callback();
    }

    handleSubmit() {
        const {
            userProfileForm,
            userProfile,
            createActions,
            preLoaderActions,
            jointHoldersStatusActions,
            consentsActions,
            immStepsState,
        } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken;
        const disabled = immStepsState.get('readOnlyForms');
        const currentIndex = immStepsState.get('currentStep');
        const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

        if (!disabled) {
            if (userProfileForm.$form.valid) {
                preLoaderActions.setInformationText(formatText('informationText-fioc'));
                preLoaderActions.showPreLoader();

                this.saveFiocData(() => {
                    this.props.actions.clientFiocVerify(accessToken, (verified, data) => {
                        if (verified) {
                            const finishAction = () => {
                                this.props.actions.finalizeStep({
                                    index: currentIndex,
                                    finished: true,
                                });

                                this.props.actions.enableFinishedAndNextStep();
                                this.props.actions.changeCurrentStep({
                                    index: currentIndex + 1,
                                });
                                preLoaderActions.hidePreLoader();
                            };
                            const onCreateClient = userId => {
                                recordEvent(
                                    PATH_PROFESSION,
                                    PAGE_PRODUCT,
                                    'tu actividad',
                                    'tu actividad correcto',
                                    userProfile.recordId,
                                    userId,
                                    '',
                                    userProfile.investmentType ? userProfile.investmentType : '',
                                    docNumberEncrypted
                                );
                                recordEventStepSuccess(
                                    userProfile.investmentType,
                                    '/onboarding/tu-actividad/',
                                    'tu actividad'
                                );

                                recordCreateNewClient(
                                    userProfile.recordId,
                                    userId,
                                    userProfile.product,
                                    userProfile.promoCode ? userProfile.promoCode : '',
                                    '',
                                    '',
                                    userProfile.investmentType ? userProfile.investmentType : '',
                                    jointHolderInfo
                                );
                            };

                            createClientWithConsent(
                                { createActions, consentsActions },
                                accessToken,
                                onCreateClient,
                                finishAction
                            );
                        } else {
                            if (data['0301']) {
                                this.props.actions.changeMinFinalizeStep({ index: 0 });
                                this.props.actions.finalizeStep({
                                    index: currentIndex,
                                    finished: true,
                                });
                                jointHoldersStatusActions.statusHolders(accessToken);
                                formActions.change('userProfile.status', 'waiting');
                            } else {
                                this.handleShowNonExclusiveModal();
                            }

                            preLoaderActions.hidePreLoader();
                        }
                    });
                });
            }
        } else {
            this.props.actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    }

    handleResetFields(accountType) {
        const { userProfile, formActions } = this.props;
        let employedFields = this.formValidations.employed.primaries;
        let selfEmployedFields = this.formValidations.selfEmployed.primaries;
        const rentier = this.formValidations.rentier.primaries;
        const pensioner = this.formValidations.pensioner.primaries;
        const withoutActivity = this.formValidations.withoutActivity.primaries;
        const accountId = accountType ? accountType : 0;
        let field;
        let fieldsToReset = [];

        let reset = true;
        if (accountType === userProfile.accountType) {
            reset = false;
        }

        if (reset) {
            if (accountId === '01') {
                selfEmployedFields = selfEmployedFields.concat(['selfEmployed_company']);
                selfEmployedFields = selfEmployedFields.concat(['profession_cnae_answer']);
                selfEmployedFields = selfEmployedFields.concat(['profession_category']);
                selfEmployedFields = selfEmployedFields.concat(['profession_id']);
                fieldsToReset = selfEmployedFields;
            }

            if (accountId === '02') {
                employedFields = employedFields.concat(['employed_company']);
                employedFields = employedFields.concat(['profession_option']);
                employedFields = employedFields.concat(['profession_category']);
                employedFields = employedFields.concat(['cno1_profession_id']);
                employedFields = employedFields.concat(['cno2_profession_id']);
                fieldsToReset = employedFields;
            }

            if (accountId === '03') {
                fieldsToReset = rentier;
            }

            if (accountId === '04') {
                fieldsToReset = pensioner;
            }

            if (accountId === '05') {
                fieldsToReset = withoutActivity;
            }

            for (let i = 0; i < fieldsToReset.length; i++) {
                field = fieldsToReset[i];
                if (typeof userProfile[field] !== 'undefined') {
                    formActions.change(`userProfile.${field}`);
                }
            }
        }
    }

    buildModalNonExclusiveKO() {
        const modalClass = `timeout-modal overwritten-modal ${this.state.blowupClass}`;

        return (
            <div>
                <Modal
                    {...this.props}
                    show={this.state.showModalNonExclusiveKO}
                    dialogClassName={modalClass}
                    backdrop="static"
                    keyboard={false}
                    animation={false}
                >
                    <Modal.Body>
                        <h3 className="font-heading3">{formatText('boxes-passErrorFiocTitle')}</h3>
                        <div className="icon-container expired-Message">
                            <p className="font-paragraph2">{formatText('boxes-passErrorFiocDescription')}</p>
                        </div>
                        <div className="form__buttons">
                            <button className="form__button form__button-secondary" onClick={this.handleBlowupClass}>
                                {formatText('button-understood')}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    handleShowNonExclusiveModal() {
        this.setState({ showModalNonExclusiveKO: true, blowupClass: 'blowup-modal blowup-in' });
    }

    handleBlowupClass() {
        this.setState({ blowupClass: 'blowup-modal blowup-out' });
        setTimeout(() => {
            this.handleHideNonExclusiveModal();
        }, 200);
    }

    handleHideNonExclusiveModal() {
        this.setState({ showModalNonExclusiveKO: false });
    }

    handleDisableButton() {
        const { userProfile } = this.props;
        const { selfEmployed, employed, rentier, pensioner, withoutActivity } = this.formValidations;

        const requiredFieldsByAccountType = {
            [SELF_EMPLOYED_ID]: selfEmployed.primaries,
            [EMPLOYED_ID]: employed.primaries,
            [RENTIER_ID]: rentier.primaries,
            [PENSIONER_ID]: pensioner.primaries,
            [WITHOUT_ACTIVITY_ID]: withoutActivity.primaries,
        };

        return requiredFieldsByAccountType[userProfile.accountType]?.some(field => !userProfile[field]);
    }

    buildForm() {
        const { userProfile, formActions } = this.props;
        const { investmentType } = userProfile;
        const accountId = userProfile.accountType ? userProfile.accountType : '';
        const disabled = this.props.immStepsState.get('readOnlyForms');
        const accountView = <AccountType typeId={accountId} disabled={disabled} {...this.props} />;
        const handleResetFields = this.handleResetFields;
        const modalNonExclusive = this.buildModalNonExclusiveKO();
        const disableButton = this.handleDisableButton();

        const wizardDescriptionByInvestmentType =
            investmentType === CREDIT_CARD
                ? formatText('stepsTitles-professionalDataDescriptionCreditCard')
                : formatText('stepsTitles-professionalDataDescription');
        const wizardDisclaimerByInvestmentType =
            investmentType === CREDIT_CARD
                ? formatText('stepsTitles-professionalDataDisclaimerCreditCard')
                : formatText('stepsTitles-professionalDataDisclaimer');

        return (
            <div>
                <Headline icon="fioc" className="prospects-gutter">
                    <h2>{formatText('stepsTitles-professionalDataTitle')}</h2>
                    <p>{wizardDescriptionByInvestmentType}</p>
                </Headline>
                <div className="account-steps profile-step-2">
                    <Form model="userProfile" onSubmit={this.handleSubmit} className="form" name="form">
                        <div className="prospects-gutter prospects-separator">
                            {modalNonExclusive}
                            <Disclaimer>
                                <label>{wizardDisclaimerByInvestmentType}</label>
                            </Disclaimer>
                            <div className="row md-form-group">
                                <div className="col-sm-8">
                                    <RadioButton
                                        profileModel="userProfile.accountType"
                                        label={formatText('field-workBy')}
                                        optionsList={this.getWorkFor()}
                                        onChange={function (value) {
                                            formActions.resetValidity('userProfile');
                                            handleResetFields(value);
                                        }}
                                        disabled={disabled}
                                        focusAnimated
                                        {...this.props}
                                    />
                                </div>
                            </div>
                            {accountView}
                        </div>
                        <div className="form__footer">
                            <RoadmapNavigation
                                buttonContinueType="submit"
                                buttonContinueAction={this.onHandleValidateFields}
                                buttonContinueFakeDisabled={disableButton}
                            />
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

    render() {
        const { userProfile, immJointHoldersStatus } = this.props;
        let block;

        if (immJointHoldersStatus.get('fetchSuccess') || userProfile.status === 'waiting') {
            block = <StandByHC />;
            window.scrollTo(0, 0);
        } else if (userProfile.status !== 'waiting') {
            block = this.buildForm();
        }

        return <div>{block}</div>;
    }
}

module.exports.constructor = ProfileStep2Reduced;
module.exports.ProfileStep2Reduced = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        extraData: state.extraData,
        options: state.options,
        focus: state.focus,
        products: state.products,
        immJointHoldersStatus: state.jointHoldersStatus,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        focusActions: bindActionCreators(focusActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
        consentsActions: bindActionCreators(consentsActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(ProfileStep2Reduced);
